import { createActions } from 'redux-actions';

export const { createOperator, updateOperator } = createActions({
  createOperator: (bodyParams, formik, onSuccess) => ({ bodyParams, formik, onSuccess }),
  updateOperator: (id, bodyParams, formik) => ({ id, bodyParams, formik }),
}, { prefix: 'MT_TOUROPERATORS' });
